<template>
  <div>
    <v-card
      color="pink darken-2"
      :class="{
        'mr-3 captureButton': $vuetify.breakpoint.mdAndUp,
        'mb-3 captureButton': $vuetify.breakpoint.smAndDown
      }"
      @click="cameraDialog = true"
    >
      <v-card-text class="white--text text-xs-center">
        <v-icon x-large color="white">photo_camera</v-icon>
        <div class="title text-xs-center">
          {{ $vuetify.t('$vuetify.calls.takePhoto') }}
        </div>
      </v-card-text>
    </v-card>
    <v-dialog fullscreen persistent v-model="cameraDialog">
      <v-card class="text-xs-center">
        <v-toolbar color="white" flat class="ml-3">
          <v-btn @click="cameraDialog = false" icon light>
            <v-icon color="grey darken-2">arrow_back</v-icon>
            <span>{{ $vuetify.t('$vuetify.app.back') }}</span>
          </v-btn>
        </v-toolbar>
        <video
          class="mt-3"
          ref="video"
          v-bind:class="{ flash: flashOn }"
          v-if="!photoTaken"
        />
        <v-img :src="src" aspect-ratio="1" class="mt-3" v-if="photoTaken">
        </v-img>
        <v-progress-linear
          :indeterminate="true"
          v-if="!isCameraReady"
        ></v-progress-linear>
        <v-btn v-if="photoTaken" @click.native="photoTaken = false">
          <span>Retake</span>
        </v-btn>
        <v-btn
          color="green"
          v-if="photoTaken"
          @click.native="savePhoto"
          :loading="saving"
        >
          <v-icon color="black">save</v-icon>
          <span>Save</span>
        </v-btn>
        <v-card
          :class="{
            'mr-3 mt-3 captureButton': $vuetify.breakpoint.mdAndUp,
            'mb-3 mt-3 captureButton': $vuetify.breakpoint.smAndDown
          }"
          @click.native="capture"
          color="pink darken-2"
          v-if="media == 'photo' && isCameraReady && photoTaken == false"
        >
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>photo_camera</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.takePicture') }}
            </div>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Howl } from 'howler'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import helpers from '../../utils/helpers'

export default {
  props: ['stage'],
  components: {},
  data() {
    return {
      cameraDialog: false,
      mediaStream: null,
      isCameraReady: false,
      screenshotFormat: {
        type: String,
        default: 'image/jpeg'
      },
      media: 'photo',
      photoFormat: {
        type: String,
        default: 'image/jpeg'
      },
      flashOn: false,
      photoTaken: false,
      src: '',
      saving: false,
      endPhoto: null
    }
  },
  mounted() {
    this.getEndPhoto()
  },
  computed: {
    ...mapGetters({
      activeCallId: 'calls/activeCallId',
      getCallById: 'calls/getCallById'
    }),
    callDetail() {
      const callDetail = this.getCallById(this.$route.params.id)
      return callDetail
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    },
    cameraDialog: function(newVal, oldVal) {
      if (newVal == true) {
        this.getStream()
      } else {
        this.stopTrack()
      }
    },
    photoTaken: function(newVal, oldVal) {
      if (newVal == false) {
        this.getStream()
      } else {
        this.stopTrack()
      }
    }
  },
  methods: {
    ...mapActions({
      addMedia: 'calls/addMedia',
      deleteMedia: 'calls/deleteMedia'
    }),

    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),

    getStream() {
      navigator.mediaDevices
        .getUserMedia({ video: { facingMode: 'environment' }, audio: false })
        .then(mediaStream => {
          this.mediaStream = mediaStream
          const v = this.$refs.video
          const self = this
          v.srcObject = mediaStream
          v.onloadedmetadata = function(e) {
            self.isCameraReady = true
            v.play()
          }
        })
        .catch(error => console.error('getUserMedia() error:', error))
    },

    stopTrack() {
      if (this.mediaStream) {
        const tracks = this.mediaStream.getTracks()
        tracks.map(track => track.stop())
      }
    },

    capture() {
      this.photoTaken = true
      this.cameraFlash()
      this.src = this.getPhoto().toDataURL(this.photoFormat)
    },

    getEndPhoto() {
      console.log(this.callDetail.media)
      const media = _.find(this.callDetail.media, function(obj) {
        return obj.custom_properties.stage == 'complete'
      })
      this.endPhoto = media
      return media
    },

    savePhoto() {
      const media = {}
      this.saving = true
      media.src = this.src
      media.type = 'image'
      media.collection_name = 'media'
      media.stage = this.stage
      media.model_id = this.activeCallId

      const maxWidth = process.env.VUE_APP_IMG_MAX_WIDTH
      const maxHeight = process.env.VUE_APP_IMG_MAX_HEIGHT
      this.getEndPhoto()
      if (
        this.endPhoto &&
        (this.endPhoto.stage == 'complete' ||
          this.endPhoto.custom_properties.stage == 'complete')
      ) {
        media.id = this.endPhoto.id
        this.deleteMedia(this.endPhoto).then(() => {
          this.addMedia({ id: media.model_id, media: media })
            .then(res => {
              this.endPhoto = media
              this.endPhoto.id = res.data.data.id
              this.cameraDialog = false
              this.photoTaken = false
              this.$emit('photo-taken', res.data.data)
              this.setNotification(this.$vuetify.t('$vuetify.calls.photoTaken'))
              this.saving = false
              this.stopTrack()
            })
            .catch(e => {
              console.log(e, 'error')
              this.stopTrack()
            })
        })
      } else {
        this.addMedia({ id: media.model_id, media: media })
          .then(res => {
            this.endPhoto = media
            this.endPhoto.id = res.data.data.id
            this.cameraDialog = false
            this.photoTaken = false
            this.$emit('photo-taken', res.data.data)
            this.setNotification(this.$vuetify.t('$vuetify.calls.photoTaken'))
            this.saving = false
            this.stopTrack()
          })
          .catch(e => {
            console.log(e, 'error')
            this.stopTrack()
          })
      }
    },

    getPhoto() {
      const video = this.$refs.video
      if (!this.ctx) {
        const canvas = document.createElement('canvas')
        canvas.height = video.clientHeight
        canvas.width = video.clientWidth
        this.canvas = canvas
        this.ctx = canvas.getContext('2d')
      }
      const { ctx, canvas } = this
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
      return canvas
    },

    async cameraFlash() {
      const sound = new Howl({
        src: ['./sounds/camera-shutter-click.mp3'],
        rate: 2
      })
      sound.play()
      this.flashOn = true
      const that = this
      await new Promise(resolve => setTimeout(resolve, 100))
      that.flashOn = false
    }
  },
  destroyed() {
    if (this.mediaStream) {
      const tracks = this.mediaStream.getTracks()
      tracks.map(track => track.stop())
    }
  }
}
</script>

<style scoped>
.captureButton {
  cursor: pointer;
}

.uploadButton {
  cursor: pointer;
}

video {
  max-width: 100%;
  max-height: 46vh;
}

.flash {
  border: 10px solid rgba(255, 255, 255, 0.8);
}

.btn-file {
  position: relative;
  overflow: hidden;
}

.btn-file input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  opacity: 0;
  outline: none;
  background: #fff;
  cursor: inherit;
  display: block;
}
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}

.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
</style>
